import { AuthService, AuthProvider, HttpService } from '@lk/api'

export const makeAuthService = (http: HttpService, baseUrl: string) => new AuthService(new AuthProvider(http, baseUrl))
